var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-header", {
    attrs: {
      "is-whitelabel": "is-whitelabel",
      "cart-route": "cart",
      "checkout-route": "checkout",
      cart: _vm.cart,
      collapsed: _vm.headerCollapsed,
      processing: _vm.processing,
      search: _vm.search,
      "marketplace-categories": _vm.marketplaceCategories,
      "menu-links": _vm.menuLinks,
      "is-mobile": _vm.isMobile,
      "is-mobile-sales-page": _vm.isMobileSalesPage,
      "scrolling-up": _vm.scrollingUp,
      "hide-fixed-header": _vm.hideFixedHeader,
      "current-scroll-top": _vm.currentScrollTop,
      "show-home-link": !_vm.domainConfig.assets.logo
    },
    on: {
      "search-input": _vm.handleSearchInput,
      "perform-search": _vm.performSearch
    },
    scopedSlots: _vm._u([
      {
        key: "logo",
        fn: function() {
          return [
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "home", params: { page: "1", nav: true } },
                  "aria-label": "Home link"
                }
              },
              [
                _vm.domainConfig.assets.logo
                  ? _c("img", {
                      staticClass: "opacity-100 h-2_75",
                      attrs: { src: _vm.domainConfig.assets.logo, alt: "Home" }
                    })
                  : _c("div", { staticClass: "h-2_75" })
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }